import store from '@/core/store'
import sessionService from '@/app-domains/user/session/session.service'
import DraftManagerService from '../draft/service/DraftManager.service'

class WritingModalService {
  constructor () {
    this.replies = {}
    this.isWritingModalOpened = false
  }

  /** OPENING METHODS */

  open (dataToFill = {}) {
    this.isWritingModalOpened = true
    store.commit('MESSAGE_MODAL:OPEN', dataToFill)
  }

  openForward (message, thread, options) {
    this.isWritingModalOpened = true
    DraftManagerService.setDraftType('forward')
    store.commit('MESSAGE_MODAL:OPEN', {
      type: 'forward',
      message,
      thread,
      defaultDomain: sessionService.getMe().me.defaultdomain,
      options
    })
  }

  openReplyToThread (message, thread, options) {
    this.isWritingModalOpened = true
    store.commit('MESSAGE_MODAL:OPEN', {
      type: 'reply',
      message,
      thread,
      defaultDomain: sessionService.getMe().me.defaultdomain,
      options,
    })
  }

  openDraft () {
    DraftManagerService.setDraftType('standalone')
    store.commit('MESSAGE_MODAL:OPEN', {
      type: 'standalone-draft',
      defaultDomain: sessionService.getMe().me.defaultdomain
    })
  }

  close () {
    this.isWritingModalOpened = false
    DraftManagerService.cleanDraft()
    store.commit('MESSAGE_MODAL:CLOSE')
  }
}

export default new WritingModalService()
